// App.tsx
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import RomdropsLanding from "./components/RomdropsLanding";
import PrivacyPolicy from "./components/PrivacyPolicy";
import EarlyAccessPage from "./components/EarlyAccessPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<RomdropsLanding />} />
        <Route path="/early-access" element={<EarlyAccessPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
  